import { apiClient } from './apiClient';

export const supplierService = {
  // Get all suppliers
  async getSuppliers() {
    return apiClient.get(`/api/cmms/suppliers`);
  },

  // Get suppliers by status
  async getSuppliersByStatus(status) {
    return apiClient.get(`/api/cmms/suppliers/status/${status}`);
  },

  // Get suppliers by type
  async getSuppliersByType(type) {
    return apiClient.get(`/api/cmms/suppliers/type/${type}`);
  },

  // Get single supplier by ID
  async getSupplierById(id) {
    return apiClient.get(`/api/cmms/suppliers/${id}`);
  },

  // Get supplier by code
  async getSupplierByCode(code) {
    return apiClient.get(`/api/cmms/suppliers/code/${code}`);
  },

  // Create new supplier
  async createSupplier(data) {
    return apiClient.post(`/api/cmms/suppliers`, data);
  },

  // Update supplier
  async updateSupplier(id, data) {
    return apiClient.put(`/api/cmms/suppliers/${id}`, data);
  },

  // Delete supplier
  async deleteSupplier(id) {
    return apiClient.delete(`/api/cmms/suppliers/${id}`);
  },
};
